import axiosBackEnd from "../config/axios/axios-back-end";

// RETRIEVE PMS DATA
/**
 * @author iresha
 * @date 2022-12-16
 */
const getPMS = async () => {
  const res = await axiosBackEnd.get(`/api/pms`);
  return res.data;
};

// GET Reports for given PMS
const getReportListByPMS = async (pmsId) => {
  const res = await axiosBackEnd.get(`/api/pms/${pmsId}/report-list`);
  return res.data;
};

// Add PMS Report
const addPMSReport = async (data) => {
  const { pmsId, ...body } = data;
  const res = await axiosBackEnd.post(`/api/pms/${pmsId}/report-list`, body);
  return res.data;
};

export const addBulkPMSReport = async (data) => {
  const response = await axiosBackEnd.post(
    "/api/pms/report/bulk-creation",
    data,
  );
  return response.data;
};

// CREATE PMS DATA
/**
 * @author iresha
 * @date 2023-01-23
 */
const createPMS = async (data) => {
  const res = await axiosBackEnd.post(`/api/pms`, data);
  return res.data;
};

// UPDATE PMS DATA
/**
 * @author iresha
 * @date 2023-01-23
 */
const updatePMS = async (data) => {
  const res = await axiosBackEnd.put(`/api/pms/${data?._id}`, data);
  return res.data;
};

// DELETE PMS DATA
/**
 * @author iresha
 * @date 2022-12-16
 */
const deletePMS = async (id) => {
  const res = await axiosBackEnd.delete(`/api/pms/${id}`);
  return res.data;
};

const updatePMSReport = async (data) => {
  const res = await axiosBackEnd.put(`/api/pms/report/${data._id}`, data);
  return res.data;
};

const deactivatePMSReport = async (data) => {
  const res = await axiosBackEnd.put(
    `/api/pms/report/${data}/deactivate`,
    data,
  );
  return res.data;
};

export {
  getPMS,
  createPMS,
  updatePMS,
  deletePMS,
  getReportListByPMS,
  addPMSReport,
  updatePMSReport,
  deactivatePMSReport,
};
